import { action } from 'satcheljs';

// Action to be called for initializing calendar surface view.
const initializeCalendarSurfaceView = action('initializeCalendarSurfaceView');

export default initializeCalendarSurfaceView;
